import { atom } from "recoil";

export const ItemNameState = atom({
    key: 'itemName',
    default:'',
});

export const ItemPriceState = atom({
    key: 'itemPrice',
    default: '',
})

export const OptionsState = atom({
    key: 'SelectValue',
    default:[
        { value: "online", label: "온라인" },
       ],
});

export const  PostObjectState = atom({
    key: 'PostObject',
    default:{},
});



